module.exports = __webpack_public_path__ + "img/alipay.cba4cfd2.jpg";